export default __webpack_public_path__ + "static/media/055-ostrich.9de6dc83.svg";